<div class=" " *ngIf="showRequest" [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.TITLE' | translate }}</h2>

     <!--request Details summary-->
     <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>
     <!--request -->
  <form [formGroup]="nonDestructiveTestingWorkForm"  *ngIf="!showSuccessMessage">

    <fieldset [disabled]="isReadOnly">
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

        <!-- QualityService -->
        <div class="form-group">
          <label for="QualityServiceId">{{'FRONT_USER.QUALITY_REQUEST_FORM.QUALITY_SERVICE' | translate}}</label>
          <span class="red"> *</span>
          <select (change)="changeQuality($event.target.value)" id="QualityServiceId" name="QualityServiceId"
            class="form-control" formControlName="QualityServiceId">
            <option [value]='undefined' selected>
              {{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_QUALITY_SERVICE_TYPE' | translate}}</option>
            <ng-container *ngFor="let quality of qualityService">
              <option *ngIf="displayedLang=='NameEN'" [value]="quality.Id">
                {{quality.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="quality.Id">
                {{quality.NameAR}}
              </option>
            </ng-container>
          </select>

          <div *ngIf="(submitted||f.QualityServiceId?.touched) && (f.QualityServiceId?.errors||f.QualityServiceId.value=='undefined')" class="red ">
            <div *ngIf="f.QualityServiceId?.errors?.required||f.QualityServiceId.value=='undefined'">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>
        </div>

        <!-- VesselType -->
        <div class="form-group">
          <label for="VesselTypeId">{{'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_TYPE' | translate}}</label>
          <span class="red"> *</span>
          <select id="VesselTypeId" name="VesselTypeId" class="form-control" formControlName="VesselTypeId">
            <option [value]='undefined' selected>{{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_VESSEL_TYPE' | translate}}
            </option>
            <ng-container *ngFor="let vessel of vesselType">
              <option *ngIf="displayedLang=='NameEN'" [value]="vessel.Id">
                {{vessel.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="vessel.Id">
                {{vessel.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="(submitted||f.VesselTypeId?.touched) &&( f.VesselTypeId?.errors||f.VesselTypeId.value=='undefined')" class="red ">
            {{'FRONT_USER.This_Field_Is_Required' | translate}}
            <div *ngIf="f.VesselTypeId?.errors?.required||f.VesselTypeId.value!='undefined'">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>
        </div>
      </div>

      <!-- If UltraSonicTest is selected -->
      <div *ngIf="testedDiv==QualityServices.UltraSonicTest">
        <div class="form-container">

          <!-- AcceptanceCriteria -->
          <div class="form-group">
            <label
              for="AcceptanceCriteriaId">{{'FRONT_USER.QUALITY_REQUEST_FORM.ACCEPTANCE_CRITERIA' | translate}}</label>
            <span class="red"> *</span>
            <select (change)="changeCriteria($event.target.value)" id="AcceptanceCriteriaId" name="AcceptanceCriteriaId"
              class="form-control" formControlName="AcceptanceCriteriaId">
              <option [value]='undefined' selected>
                {{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_ACCEPTANCE_CRITERIA' | translate}}</option>
              <ng-container *ngFor="let criteria of acceptanceCriteria">
                <option *ngIf="displayedLang=='NameEN'" [value]="criteria.Id">
                  {{criteria.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="criteria.Id">
                  {{criteria.NameAR}}
                </option>
              </ng-container>
            </select>
            <div *ngIf="(submitted ||f.AcceptanceCriteriaId?.touched)&& (f.AcceptanceCriteriaId?.errors||f.AcceptanceCriteriaId?.value=='undefined')"
              class="red ">
              <div *ngIf="f.AcceptanceCriteriaId?.errors?.required||f.AcceptanceCriteriaId?.value=='undefined'">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <!--  OthersAcceptanceCriteria -->
          <div class="form-group" *ngIf="showOtherDiv">
            <label
              for=" OthersAcceptanceCriteria">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.OTHer_ACCEPTANCE_CRITERIA' | translate}}</label>
            <span class="red"> *</span>
            <input type="text" class="form-control" id=" OthersAcceptanceCriteria" name=" OthersAcceptanceCriteria"
              formControlName="OthersAcceptanceCriteria" />
            <div *ngIf="submitted ||( f.OthersAcceptanceCriteria?.errors&& f.OthersAcceptanceCriteria?.touched)"
              class="red ">
              <div *ngIf="f.OthersAcceptanceCriteria?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.OthersAcceptanceCriteria?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f. OthersAcceptanceCriteria?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
            </div>
          </div>

          <!-- DateOfMeasurement -->
          <div class="form-group">
            <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.DATE_OF_PRICE_QUOTATION'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="DateOfMeasurement"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' , containerClass : 'theme-dark-blue'}">

            <div *ngIf="submitted ||(f.DateOfMeasurement?.errors&&f.DateOfMeasurement?.touched)" class="red ">
              <div *ngIf="f.DateOfMeasurement?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.DateOfMeasurement?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}</div>


            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="form-container">
          <div class="form-group">
            <label for="Description">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.BRIEF_DESCRIPTION' | translate}}</label>
            <span class="red"> *</span>
            <textarea class="form-control" id="Description" name="Description" formControlName="Description"
              style="height: 186px;  width: 400px;"></textarea>
            <div *ngIf="submitted ||(f.Description?.errors&&f.Description?.dirty)" class="red ">
              <div *ngIf="f.Description?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.Description?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              <div *ngIf="f.Description?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>

            </div>
          </div>
        </div>
        <div *ngIf="!isReadOnly">
          <div class="form-container">
            <!-- Attachment Title -->
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>

            <!-- Drawings -->
            <div class="form-group">
              <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS'|translate}}</label>
              <span class="red">*</span>
              <input type="file" class="form-control" MaxSizeInMB="5"
                accept=".pdf,.gif, .jpg, .jpeg,.png,.bmp,.doc,.docx" id="Drawings" formControlName="Drawings"
                (change)="onFileSelected($event,f.Drawings,'Non_Destructive_Drawings',11,'executiveDrawingsProgress','FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS')" />
              <div class="upload-info">
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
              </div>
              <div *ngIf="submitted && f.Drawings?.errors ||(f.Drawings?.errors && f.Drawings?.dirty)" class="red ">
                  {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
                </div>

              <!-- progress-bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="executiveDrawingsProgress + '%'">
                  <span class=""> {{executiveDrawingsProgress}} % Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Drawings in view mode -->
        <div *ngIf="isReadOnly">
          <div class="form-container">
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
            <div class="form-group  read-uploaded">
              <label>{{ 'FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS' | translate}}</label>
              <a [attr.href]="drawingAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- If VibrationTestAndAnalysis selected -->
      <div *ngIf="testedDiv==QualityServices.VibrationTestAndAnalysis">
        <div class="form-container">

          <!-- MachineType -->
          <div class="form-group">
            <label for="MachineTypeId">{{'FRONT_USER.QUALITY_REQUEST_FORM.TYPE_OF_EQUIPMENT' | translate}}</label>
            <span class="red"> *</span>
            <select (change)="changeMachineType($event.target.value)" id="MachineTypeId" name="MachineTypeId"
              class="form-control" formControlName="MachineTypeId">
              <option [value]='undefined' selected>
                {{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_EQUIPMENT_TYPE' | translate}}
              </option>
              <ng-container *ngFor="let equipment of equipmentType">
                <option *ngIf="displayedLang=='NameEN'" [value]="equipment.Id">
                  {{equipment.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="equipment.Id">
                  {{equipment.NameAR}}
                </option>
              </ng-container>
            </select>

            <div *ngIf="(submitted||f.MachineTypeId?.touched)&&(f.MachineTypeId?.errors||f.MachineTypeId?.value=='undefined')" class="red ">
              <div *ngIf="f.MachineTypeId?.errors?.required||f.MachineTypeId?.value=='undefined'">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
          <!-- MachineTypeOthers -->
          <div class="form-group" *ngIf="showMachineDiv">
            <label for="OthersMachineType">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.OTHER_MACHINE_TYPE' | translate}}</label>
            <span class="red"> *</span>
            <input type="text" class="form-control" id="OthersMachineType" name="OthersMachineType"
              formControlName="OthersMachineType" />
            <div *ngIf="submitted ||(f.OthersMachineType?.errors&&f.OthersMachineType?.dirty)" class="red ">
              <div *ngIf="f.OthersMachineType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.OthersMachineType?.errors?.maxlength"> {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="f.OthersMachineType?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div>
              <div *ngIf="f.OthersMachineType?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
            </div>
          </div>

          <!-- BaseType -->
          <div class ="form-group">
            <label id="example-radio-group-label">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.BASE_TYPE' | translate }}</label>
            <span class="red"> *</span>
            <div class="form-custom-inputs">
              <div class="custom-Radio"  *ngFor="let base of baseTypeKeys;let i='index'">
                <input [id]="[base]"  type="radio"  name="BaseTypeId"  [value]="baseType[base]"
                   formControlName="BaseTypeId" />
                <label [for]="[base]">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.'+base | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted && f.BaseTypeId?.errors" class="red ">
              <div *ngIf="f.BaseTypeId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            </div>
          </div>

          <!-- CouplingType -->
          <div class="form-group">
            <label for="CouplingType">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.COUPLING' | translate}}</label>
            <span class="red"> *</span>
            <input type="text" class="form-control" id="CouplingType" name="CouplingType"
              formControlName="CouplingType" />
            <div *ngIf="submitted ||(f.CouplingType?.errors&&f.CouplingType?.dirty)" class="red ">
              <div *ngIf="f.CouplingType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.CouplingType?.errors?.maxlength"> {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <!-- <div *ngIf="f.CouplingType?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div> -->
              <div *ngIf="f.CouplingType?.errors?.startsWithSpaceError"> {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>

          <!-- RPM -->
          <div class="form-group">
            <label for="RPM">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.RPM' | translate}}</label>
            <span class="red"> *</span>
            <input type="text" class="form-control" id="RPM" name="RPM" formControlName="RPM" />
            <div *ngIf="submitted ||(f.RPM?.errors&&f.RPM?.dirty)" class="red ">
              <div *ngIf="f.RPM?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.RPM?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
            </div>
          </div>

          <!-- KW -->
          <div class="form-group">
            <label for="KW">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.KW' | translate}}</label>
            <span class="red"> *</span>
            <div class="split-form-group-units">
              <input type="text" class="form-control" id="KW" name="KW" formControlName="KW" />
              <select id="KWUnit" name="KWUnit" class="form-control" formControlName="KWUnit">
                <option [value]='null' selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                <option *ngFor="let mesurement of kwUnitKeys"  [value]="kwUnit[mesurement]">
                  {{'FRONT_USER.QUALITY_REQUEST_FORM.'+mesurement | translate}}
              </select>
            </div>
            <div *ngIf="submitted ||( f.KW?.errors&&f.KW?.dirty)" class="red ">
              <div *ngIf="f.KW?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.KW?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
            </div>
            <div *ngIf="(submitted||f.KWUnit?.touched)&& (f.KWUnit?.errors||f.KWUnit?.value=='null')" class="red ">
              <div *ngIf="f.KWUnit?.errors?.required||f.KWUnit?.value=='null'"> {{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
            </div>
          </div>
        </div>

        <!-- Details -->
        <div class="form-container">
          <div class="form-group">
            <label for="Details">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DETAILS' | translate}}</label>
            <span class="red"> *</span>
            <textarea class="form-control" id="Details" name="Details" formControlName="Details"
              style="height: 186px;  width: 400px;"></textarea>
            <div *ngIf="submitted ||( f.Details?.errors&&f.Details?.dirty)" class="red ">
              <div *ngIf="f.Details?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.Details?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              <div *ngIf="f.Details?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>

            </div>
          </div>
        </div>
      </div>

      <!-- if LiquedPenetrantTest selected -->
      <div *ngIf="testedDiv==QualityServices.LiquedPenetrantTest">
        <div class="form-container">

          <!-- DesiredDate -->
          <div class="form-group">
            <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.DESIRED_DATE'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="DesiredDate"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' , containerClass : 'theme-dark-blue'}">

            <div *ngIf="submitted ||(f.DesiredDate?.errors  && f.DesiredDate?.dirty)" class="red ">
              <div *ngIf="f.DesiredDate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}</div>
              <div *ngIf="f.DesiredDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            </div>
          </div>

          <!-- Cleaner -->
          <div class="form-group">
            <label for="Cleaner">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.CLEANER' | translate}}</label>
            <input type="text" class="form-control" id="Cleaner" name="Cleaner" formControlName="Cleaner" />
            <div *ngIf="submitted ||( f.Cleaner?.errors&& f.Cleaner?.dirty)" class="red ">
              <div *ngIf="f.Cleaner?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f.Cleaner?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
              <!-- <div *ngIf="f.Cleaner?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div> -->

            </div>
          </div>

          <!-- Penetrant -->
          <div class="form-group">
            <label for="Penetrant">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.PENETRANT' | translate}}</label>
            <input type="text" class="form-control" id="Cleaner" name="Penetrant" formControlName="Penetrant" />
            <div *ngIf="submitted ||( f.Penetrant?.errors&& f.Penetrant?.dirty)" class="red ">
              <div *ngIf="f.Penetrant?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f.Penetrant?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
              <!-- <div *ngIf="f.Penetrant?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div> -->
            </div>
          </div>

          <!-- Developer -->
          <div class="form-group">
            <label for="Developer">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DEVELOPER' | translate}}</label>
            <input type="text" class="form-control" id="Developer" name="Developer" formControlName="Developer" />
            <div *ngIf="submitted ||( f.Developer?.errors&& f.Developer?.dirty)" class="red ">
              <div *ngIf="f.Developer?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f.Developer?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
              <!-- <div *ngIf="f.Developer?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div> -->
            </div>
          </div>

          <!-- BriefDescription -->
          <div class="form-group">
            <label for="Description">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DESCRIPTION' | translate}}</label>
            <span class="red"> *</span>
            <textarea class="form-control" id="Description" name="Description"
              formControlName="Description" style="height: 186px;  width: 400px;"></textarea>
            <div *ngIf="submitted ||( f.Description?.errors&&f.Description?.dirty)" class="red ">
              <div *ngIf="f.Description?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.Description?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              <div *ngIf="f.Description?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}</div>

            </div>
          </div>

        </div>

        <div *ngIf="!isReadOnly">
          <div class="form-container">

            <!-- Attachment Title -->
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>

            <!-- Drawings -->
            <div class="form-group">
              <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS'|translate}}</label>
              <input type="file" class="form-control" MaxSizeInMB="5"
                accept=".pdf,.gif, .jpg, .jpeg,.png,.bmp,.doc,.docx" id="Drawings" formControlName="Drawings"
                (change)="onFileSelected($event,f.Drawings,'Non_Destructive_Drawings',11,'DrawingsProgress','FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS')" />
              <div class="upload-info">
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
              </div>
              <div *ngIf="submitted && f.Drawings?.errors ||(f.Drawings?.errors && f.Drawings?.dirty)" class="red ">
                  {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
                </div>
              <!-- progress-bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="DrawingsProgress + '%'">
                  <span class=""> {{DrawingsProgress}} % Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isReadOnly && drawingAttachmentExist">
          <div class="form-container">
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>

            <!-- Drawings in view mode -->
            <div class="form-group read-uploaded">
              <label>{{ 'FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS' | translate}}</label>
              <br>
              <a [attr.href]="drawingAttachmentUrl" target="_blank">
                  <i class="icon-view-file"></i>
                  {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}

              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- if ElectroMagneticTest selected -->
      <div *ngIf="testedDiv==QualityServices.ElectroMagneticTest">
        <div class="form-container">

          <!-- DesiredDate -->
          <div class="form-group">
            <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.DESIRED_DATE'|translate}}</label>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="DesiredDate"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass : 'theme-dark-blue' }">
            <div *ngIf="submitted ||(f.DesiredDate?.errors&&f.DesiredDate?.dirty)" class="red ">
              <div *ngIf="f.DesiredDate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}</div>
            </div>
          </div>

          <!-- TypeOfMagnet -->
          <div class="form-group">
            <label for="TypeOfMagnetId">{{'FRONT_USER.QUALITY_REQUEST_FORM.TYPE_OF_MAGENT' | translate}}</label>
            <select id="TypeOfMagnetId" name="TypeOfMagnetId" class="form-control" formControlName="TypeOfMagnetId">
              <option [value]='null' selected>
                {{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_TYPE_OF_MAGENT' | translate}}
              </option>
              <ng-container *ngFor="let magentType of typeOfMagent">
                <option *ngIf="displayedLang=='NameEN'" [value]="magentType.Id">
                  {{magentType.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="magentType.Id">
                  {{magentType.NameAR}}
                </option>
              </ng-container>
            </select>
          </div>

          <!-- Cleaner -->
          <div class="form-group">
            <label for="Cleaner">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.CLEANER' | translate}}</label>
            <input type="text" class="form-control" id="Cleaner" name="Cleaner" formControlName="Cleaner" />
            <div *ngIf="submitted ||( f.Cleaner?.errors&& f.Cleaner?.dirty)" class="red ">
              <div *ngIf="f.Cleaner?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f.Cleaner?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
              <!-- <div *ngIf="f.Cleaner?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div> -->
            </div>
          </div>

          <!-- WhiteBackground -->
          <div class="form-group">
            <label for="WhiteBackground">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.WHITE_BACKGROUND' | translate}}</label>
            <input type="text" class="form-control" id="WhiteBackground" name="BlackInk"
              formControlName="WhiteBackground" />
            <div *ngIf="submitted ||( f.WhiteBackground?.errors&& f.WhiteBackground?.dirty)" class="red ">
              <div *ngIf="f.WhiteBackground?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="f.WhiteBackground?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="f.WhiteBackground?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div>
            </div>
          </div>

          <!-- BlackInk -->
          <div class="form-group">
            <label for="BlackInk">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.BLACK_INK' | translate}}</label>
            <input type="text" class="form-control" id="BlackInk" name="BlackInk" formControlName="BlackInk" />
            <div *ngIf="submitted ||( f.BlackInk?.errors&& f.BlackInk?.dirty)" class="red ">
              <div *ngIf="f.BlackInk?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
              <div *ngIf="f.BlackInk?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>
              <div *ngIf="f.BlackInk?.errors?.pattern"> {{'FRONT_USER.CHARACTER_ERROR' | translate}}</div>
            </div>
          </div>

          <!-- Description -->
          <div class="form-group">
            <label for="Description">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.BRIEF_DESCRIPTION' | translate}}</label>
            <textarea class="form-control" id="Description" name="Description" formControlName="Description"
              style="height: 186px;  width: 400px;"></textarea>
            <div *ngIf="submitted ||( f.Description?.errors&& f.Description?.dirty)" class="red ">
              <div *ngIf="f.Description?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.Description?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              <div *ngIf="f.Description?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>

            </div>

          </div>

        </div>

        <div *ngIf="!isReadOnly">
          <div class="form-container">

            <!-- Attachment Title -->
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>

            <!-- Drawings -->
            <div class="form-group">
              <label>{{'FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS'|translate}}</label>
              <input type="file" class="form-control" MaxSizeInMB="5"
                accept=".pdf,.gif, .jpg, .jpeg,.png,.bmp,.doc,.docx" id="Drawings" formControlName="Drawings"
                (change)="onFileSelected($event,f.Drawings,'Non_Destructive_Drawings',11,'DrawingsProgress','FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS')" />
              <div class="upload-info">
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
              </div>
              <div *ngIf="submitted && f.Drawings?.errors ||(f.Drawings?.errors && f.Drawings?.dirty)" class="red ">
                  {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
                </div>
              <!-- progress-bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="DrawingsProgress + '%'">
                  <span class=""> {{DrawingsProgress}} % Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Drwings in view mode -->
        <div *ngIf="isReadOnly && drawingAttachmentExist ">
          <div class="form-container read-uploaded">
            <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
            <div class="form-group">
              <label>{{ 'FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS' | translate}}</label>
              <a [attr.href]="drawingAttachmentUrl" target="_blank">
                  <i class="icon-view-file"></i>
                  {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}

                </a>
            </div>
          </div>
        </div>
      </div>

      <!-- if RadioGraphicTest selected -->
      <div *ngIf="testedDiv==QualityServices.RadioGraphicTest">
        <div class="form-container">

          <!-- MaterialForm -->
          <div class="form-group">
            <label for="MaterialFormId">{{'FRONT_USER.QUALITY_REQUEST_FORM.MATERIAL_FORM' | translate}}</label>
            <select id="MaterialFormId" name="MaterialFormId" class="form-control" formControlName="MaterialFormId">
              <option [value]='null' selected>
                {{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_MATERIAL_FORM' | translate}}
              </option>
              <ng-container *ngFor="let material of materialForm">
                <option *ngIf="displayedLang=='NameEN'" [value]="material.Id">
                  {{material.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="material.Id">
                  {{material.NameAR}}
                </option>
              </ng-container>
            </select>
          </div>

          <!-- FilmType -->
          <div class="form-group">
            <label for="MaterialFormId">{{'FRONT_USER.QUALITY_REQUEST_FORM.FILM_TYPE' | translate}}</label>
            <select id="FilmTypeId" name="FilmTypeId" class="form-control" formControlName="FilmTypeId">
              <option [value]='null' selected>{{'FRONT_USER.QUALITY_REQUEST_FORM.CHOOSE_FILM_TYPE' | translate}}
              </option>
              <ng-container *ngFor="let film of filmType">
                <option *ngIf="displayedLang=='NameEN'" [value]="film.Id">
                  {{film.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="film.Id">
                  {{film.NameAR}}
                </option>
              </ng-container>
            </select>
          </div>

          <!-- MaterialThickness -->
          <div class="form-group">
            <label for="MaterialThickness">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.MATERIAL_THICKNESS' | translate}}</label>
            <div class="split-form-group-units">
              <input type="text" class="form-control" id="MaterialThickness" name="MaterialThickness"
                formControlName="MaterialThickness" />
              <select id="MaterialThicknessUnit" name="MaterialThicknessUnit" class="form-control"
                formControlName="MaterialThicknessUnit">
                <option [value]='null' selected>{{'FRONT_USER.CHOOSE' | translate}}</option>
                <option *ngFor="let mesurement of materiallThiknessUnitKeys"
                   [value]="materiallThiknessUnit[mesurement]">
                  {{'FRONT_USER.QUALITY_REQUEST_FORM.'+mesurement | translate}}
              </select>
            </div>

            <div *ngIf="submitted ||( f.MaterialThickness?.errors&&f.MaterialThickness?.dirty)" class="red ">
              <div *ngIf="f.MaterialThickness?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
            </div>

          </div>
        </div>
      </div>

      <div >

      <!-- User Info -->
      <app-user-request-details [UserRequestDetailsformGroup]="nonDestructiveTestingWorkForm" [IsReadOnly]="isReadOnly"
        [SubmitFlag]="submitted" [extrnalData]="userInfo"  [IsCustomerName]="true"></app-user-request-details>

              <!-- VesselName -->
              <div class="form-container">
                <div class="form-group">
                  <label for="VesselName">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_NAME' | translate}}</label>
                  <!-- <span class="red"> *</span> -->
                  <input type="text" class="form-control" id="VesselName" name="VesselName" formControlName="VesselName" />
                  <div *ngIf="submitted ||( f.VesselName?.errors&& f.VesselName?.dirty)" class="red ">
                    <!-- <div *ngIf="f.VesselName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div> -->
                    <div *ngIf="f.VesselName?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
                    <div *ngIf="f.VesselName?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
                    </div>

                  </div>
                </div>

                <!-- NearestLocation -->
                <div class="form-group">
                  <label id="example-radio-group-label">{{'FRONT_USER.Floating_Carnes_Request_Form.NearestLocation'|translate}}</label>
                  <span class="red"> *</span>
                  <div class="form-custom-inputs">
                    <div class="custom-Radio"  *ngFor="let location of nearestLocationKeys;let i='index'">
                      <input [id]="[location]"  type="radio"  name="NearestLocation"  [value]="nearestLocation[location]"
                         formControlName="NearestLocation" />
                      <label [for]="[location]">{{'FRONT_USER.REPAIR_REQUEST_FORM.' + location | translate }}</label>
                    </div>
                  </div>
                  <div *ngIf="submitted && f.NearestLocation?.errors" class="red ">
                    <div *ngIf="f.NearestLocation?.errors?.required">
                      {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
      <!-- TermsAndConditions -->
      <div class="form-group" *ngIf="!isReadOnly">
        <label for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
        <span class="red"> *</span>
        <div class="custom-checkbox">
          <input type="checkbox" class="form-control" id="TermsAndConditions" name="TermsAndConditions"
            formControlName="TermsAndConditions" />
          <label for="TermsAndConditions">
              <a (click)="goToTermsAndConditions()" target="_blank" >{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS_Acceptence' | translate }}</a>
          </label>
        </div>
        <div *ngIf="submitted && f.TermsAndConditions?.errors" class="red ">
          <div *ngIf="f.TermsAndConditions?.errors?.required">
            {{ 'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate }}</div>
        </div>

      </div>


      <!-- button submit -->
      <div class="form-group" *ngIf="!isReadOnly">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
      </div>
    </fieldset>
  </form>
</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace"> {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<div *ngIf="requestId">
  <app-messaging></app-messaging>
</div>
